export default __webpack_public_path__ + "static/media/2.ef6ccc83.jpg";